import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const getDimension = (params) => {
    const { id, pathsContext } = params;

    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/dimensions/${id}`).then((body) => {
            dispatch({
                type: ACTIONS.GET_DIMENSION,
                payload: {
                    dimension: body
                }
            });
        });
};

export const postDimension = (params) => {
    const { body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/dimensions`;
    const fetchOptions = {
        method: 'POST',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_DIMENSION_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.POST_DIMENSION_SUCCESS,
                    payload: {
                        dimension: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

export const putDimension = (params) => {
    const { id, body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/dimensions/${id}`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_DIMENSION_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.PUT_DIMENSION_SUCCESS,
                    payload: {
                        dimension: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

export const getManyDimensions = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/dimensions`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_MANY_DIMENSIONS,
                    payload: {
                        dimensions: body
                    }
                });
                return body;
            })
            .catch(console.error);
};

export const getExplorePageDimensions = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/contentcatalog`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_EXPLORE_PAGE_DIMENSIONS,
                    payload: {
                        body
                    }
                });
                return body;
            })
            .catch(console.error);
}
